/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decrease_QuantityInputs */

const en_decrease_quantity = /** @type {(inputs: Decrease_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decrease quantity`)
};

const th_decrease_quantity = /** @type {(inputs: Decrease_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลดจำนวน`)
};

const ja_decrease_quantity = /** @type {(inputs: Decrease_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数量を減らす`)
};

const fr_decrease_quantity = /** @type {(inputs: Decrease_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminuer la quantité`)
};

const es_decrease_quantity = /** @type {(inputs: Decrease_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reducir cantidad`)
};

const ru_decrease_quantity = /** @type {(inputs: Decrease_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уменьшить количество`)
};

const zh_decrease_quantity = /** @type {(inputs: Decrease_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减少数量`)
};

const vi_decrease_quantity = /** @type {(inputs: Decrease_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm số lượng`)
};

/**
* | output |
* | --- |
* | "Decrease quantity" |
*
* @param {Decrease_QuantityInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const decrease_quantity = /** @type {((inputs?: Decrease_QuantityInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decrease_QuantityInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_decrease_quantity(inputs)
	if (locale === "ja") return ja_decrease_quantity(inputs)
	if (locale === "fr") return fr_decrease_quantity(inputs)
	if (locale === "es") return es_decrease_quantity(inputs)
	if (locale === "ru") return ru_decrease_quantity(inputs)
	if (locale === "zh") return zh_decrease_quantity(inputs)
	if (locale === "vi") return vi_decrease_quantity(inputs)
	return en_decrease_quantity(inputs)
});